<div class="ou-list-title">Szervezeti Egységek</div>
<div class="ou-list-card" *ngFor="let item of ouList;" (click)="get(item)">
    <p>{{item.niceName}}</p>
</div>
